const reducer = (state = '', action) =>{
    switch(action.type){
        case "setRebateSummarySearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  